import React, { useState } from 'react';
import { usePopularAssetsQuery } from 'src/api/queries/deliveryAnalyticsQueries';
import { DeliveryAnalyticsFilters } from 'src/types/TDeliveryAnalytics';
import AssetsTable from '../components/AssetsTable';
import { AsyncSection, DataAsOfBadge, Section } from '../components/common';
import styles from '../styles.module.scss';

const PopularAssetsTab: React.FC<{ filters: DeliveryAnalyticsFilters }> = ({ filters }) => {
  const [metric, setMetric] = useState<'requests' | 'bytes'>('requests');
  const { data, isLoading, error } = usePopularAssetsQuery({ ...filters, metric, limit: 100 });
  const rows = data?.data ?? [];

  return (
    <Section
      title="Most-requested assets"
      description="Top assets by delivery volume over the selected range."
      headerRight={
        <div className={styles.inlineControls}>
          <div className={styles.segmented}>
            <button
              type="button"
              className={metric === 'requests' ? styles.segmentedActive : ''}
              onClick={() => setMetric('requests')}
            >
              By requests
            </button>
            <button
              type="button"
              className={metric === 'bytes' ? styles.segmentedActive : ''}
              onClick={() => setMetric('bytes')}
            >
              By bytes
            </button>
          </div>
          <DataAsOfBadge value={data?.data_as_of} loading={isLoading} />
        </div>
      }
    >
      <AsyncSection isLoading={isLoading} error={error} isEmpty={rows.length === 0}>
        <AssetsTable rows={rows} showActions />
      </AsyncSection>
    </Section>
  );
};

export default PopularAssetsTab;
